import Skeleton from "react-loading-skeleton";
import ProductGridSkeleton from "./ProductGridSkeleton";
import "./PdpSectionSkeletons.css";

export const PdpRelatedSkeleton = ({ count = 4 }) => (
  <div className="pdp-section-skeleton pdp-section-skeleton--related" aria-hidden="true">
    <ProductGridSkeleton count={count} />
  </div>
);

export const PdpReviewsSkeleton = () => (
  <div className="pdp-section-skeleton pdp-section-skeleton--reviews" aria-hidden="true">
    <Skeleton width={200} height={16} borderRadius={4} />
    <div className="pdp-section-skeleton__review-cards">
      {Array.from({ length: 2 }).map((_, i) => (
        <div key={i} className="pdp-section-skeleton__review-card">
          <Skeleton width={120} height={14} borderRadius={4} />
          <Skeleton width={88} height={12} borderRadius={4} />
          <Skeleton count={2} height={12} borderRadius={4} />
        </div>
      ))}
    </div>
  </div>
);
